import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleItaliano() {
  return <ArticleLayout article={articleContents['itaobuy-spreadsheet-italiano']} />;
}